<!-- DARK THEME FOOTER -->

<footer class="relative py-16 border-t border-varroc-border bg-gradient-to-br from-black via-varroc-darker to-black text-white overflow-hidden futuristic-footer">
  <!-- Futuristic Glow/Blur Effects -->
  <div class="absolute -top-32 -left-32 w-96 h-96 bg-varroc-accent/10 rounded-full blur-3xl pointer-events-none animate-pulse"></div>
  <div class="absolute -bottom-32 -right-32 w-[32rem] h-[32rem] bg-varroc-accent/10 rounded-full blur-3xl pointer-events-none animate-pulse"></div>

  <div class="max-w-7xl mx-auto px-6 relative z-10">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
      <!-- Logo & Contact Column -->
      <div class="lg:col-span-1 flex flex-col gap-6">
        <div class="flex items-center gap-3 mb-2">
          <a routerLink="/" aria-label="Varroc Connect Home">
            <img [src]="Images.VARROC_CONNECT_WHITE_LOGO" alt="Varroc Connect Logo" class="h-12 drop-shadow-neon">
          </a>
        </div>
        <p class="text-varroc-text-muted text-sm font-medium mb-2 tracking-wide">Connected Vehicle Intelligence for the future of mobility.</p>
        <div class="mb-2">
          <p class="text-xs font-bold tracking-widest uppercase text-varroc-text-gray mb-1">Contact Us</p>
          <a href="mailto:{{SupportEmail}}" class="text-sm text-varroc-accent hover:underline transition-all font-semibold tracking-wide footer_email_click">
            {{SupportEmail}}
          </a>
          <div class="mt-2">
            <a href="tel:+919579292320" class="text-sm text-varroc-text-gray hover:text-varroc-accent transition-all tracking-wide flex items-center gap-1 footer_phone_click">
              <i class='bx bx-phone text-base'></i> +91 95792 92320
            </a>
          </div>
        </div>
        <div>
          <p class="text-xs font-bold tracking-widest uppercase text-varroc-text-gray mb-1">Address</p>
          <p class="text-xs text-varroc-text-muted leading-relaxed">Varroc Tech Center, Elpro International, Chinchwad Station Rd, Pimpri-Chinchwad,<br>Maharashtra 411033</p>
        </div>
        <div>
          <p class="text-xs font-bold tracking-widest uppercase text-varroc-text-gray mb-2">Get it On</p>
          <div class="flex flex-row gap-2">
            <a href="{{ANDROID_APP_LINK}}" target="_blank" rel="noopener noreferrer" class="hover:scale-105 transition-transform">
              <img [src]="Images.FOOTER_PLAYSTORE" alt="Download on Google Play" class="w-36 drop-shadow-neon footer_google_play_app_button">
            </a>
            <a href="{{IOS_APP_LINK}}" target="_blank" rel="noopener noreferrer" class="hover:scale-105 transition-transform">
              <img [src]="Images.FOOTER_APPSTORE" alt="Download on the App Store" class="w-36 drop-shadow-neon footer_app_store_button">
            </a>
          </div>
        </div>
      </div>

      <!-- Company Column -->
      <div>
        <h4 class="text-xl font-bold mb-5 text-varroc-accent tracking-wide futuristic-underline">Company</h4>
        <ul class="space-y-3 text-varroc-text-gray text-sm">
          <li><a routerLink={{Routes.about_us}} class="hover:text-varroc-accent transition cursor-pointer">About Us</a></li>
          <li><a routerLink={{Routes.leadership}} class="hover:text-varroc-accent transition cursor-pointer">Leadership</a></li>
          <li><a routerLink={{Routes.careers}} class="hover:text-varroc-accent transition cursor-pointer">Careers</a></li>
          <li><a href="http://varrocconnect.com/blog" target="_blank" rel="noopener noreferrer" class="hover:text-varroc-accent transition">Blogs</a></li>
        </ul>
      </div>

      <!-- Legal & Store Column -->
      <div>
        <h4 class="text-xl font-bold mb-5 text-varroc-accent tracking-wide futuristic-underline">Legal & Store</h4>
        <ul class="space-y-3 text-varroc-text-gray text-sm mb-6">
          <li><a routerLink={{Routes.privacy_policy}} class="hover:text-varroc-accent transition cursor-pointer">Privacy Policy</a></li>
          <li><a routerLink={{Routes.terms_and_conditions}} class="hover:text-varroc-accent transition cursor-pointer">Terms & Conditions</a></li>
          <li><a routerLink={{Routes.refund_and_return}} class="hover:text-varroc-accent transition cursor-pointer">Refund & Return</a></li>
          <li><a routerLink={{Routes.cyber_security}} class="hover:text-varroc-accent transition cursor-pointer">Cyber Security</a></li>
        </ul>
        <div>
          <p class="text-xs font-bold tracking-widest uppercase text-varroc-text-gray mb-2">Try it Today</p>
          <p class="text-sm text-varroc-text-muted mb-3">Get started for free. Add your whole team as your needs grow.</p>
          <a routerLink="/store/product" class="inline-block bg-varroc-accent px-6 py-3 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition text-sm font-semibold tracking-wide footer_go_to_store_button">
            Go To Store
          </a>
        </div>
      </div>

      <!-- Platform & Products Column -->
      <div>
        <h4 class="text-xl font-bold mb-5 text-varroc-accent tracking-wide futuristic-underline">Product & Solutions</h4>
        <ul class="space-y-3 text-varroc-text-gray text-sm">
          <li><a routerLink="/products/connectiq" class="hover:text-varroc-accent transition cursor-pointer">ConnectIQ</a></li>
          <li><a routerLink="/products/unifiedsdk" class="hover:text-varroc-accent transition cursor-pointer">Unified SDK</a></li>
          <li><a routerLink="/products/hardware" class="hover:text-varroc-accent transition cursor-pointer">Hardware Devices</a></li>
          <li class="pt-1"><a routerLink="/solutions/business" class="hover:text-varroc-accent transition cursor-pointer">Solutions for Business</a></li>
          <li><a routerLink="/solutions/consumers" class="hover:text-varroc-accent transition cursor-pointer">Solutions for Consumers</a></li>
          <li class="pt-1"><a routerLink="/resources" class="hover:text-varroc-accent transition cursor-pointer">Resources</a></li>
          <li><a href="/html-sitemap.html" class="hover:text-varroc-accent transition">HTML Sitemap</a></li>
        </ul>
      </div>

      <!-- Social/Contact/CTA Column -->
      <div class="flex flex-col gap-8 justify-between">
        <div>
          <h4 class="text-xl font-bold mb-5 text-varroc-accent tracking-wide futuristic-underline">Connect</h4>
          <div class="flex gap-4 mb-4">
            <a href="https://www.linkedin.com/company/varrocconnect/" target="_blank"  rel="nofollow noopener noreferrer"  aria-label="LinkedIn" class="hover:icon-gradient transition text-2xl"><i class='bx bxl-linkedin'></i></a>
            <a href="https://twitter.com/varrocconnect" target="_blank" rel="nofollow noopener noreferrer" aria-label="Twitter" class="hover:icon-gradient transition text-2xl"><i class='bx bxl-twitter'></i></a>
            <a href="https://www.facebook.com/varrocconnect/" target="_blank" rel="nofollow noopener noreferrer" aria-label="Facebook" class="hover:icon-gradient transition text-2xl"><i class='bx bxl-facebook'></i></a>
            <a href="https://www.instagram.com/varroc_connect" target="_blank" rel="nofollow noopener noreferrer" aria-label="Instagram" class="hover:icon-gradient transition text-2xl"><i class='bx bxl-instagram'></i></a>
          </div>
          <a routerLink={{Routes.contact}} class="inline-block bg-gradient-to-r from-varroc-accent to-varroc-accent-hover px-6 py-3 rounded-xl hover:shadow-neon transition text-sm font-semibold tracking-wide mt-2 footer_contact_us_button">Contact</a>
        </div>
      </div>
    </div>

    <!-- Copyright -->
    <div class="border-t border-varroc-border pt-8 text-center text-sm text-varroc-text-dark tracking-wide flex flex-col md:flex-row items-center justify-between gap-4">
      <span>© {{ currentYear }} Varroc Connect. All rights reserved.</span>
      <span class="text-varroc-text-gray">Empowering Safer, Smarter Connectivity</span>
    </div>
  </div>
</footer>